module.exports = __webpack_public_path__ + "static/6305-woodrose-48-d94b6790a8ab99a6c7bc1cad140afdba.jpg";